module.exports = __webpack_public_path__ + "img/ss-sched-sketch.0fbfbd7d.jpg";